import axios from "axios";
import UrlConfigs from "../configs/UrlConfig";

export default axios.create({
  baseURL: UrlConfigs.API_URL,
  //baseURL: 'http://localhost:8008/',
  headers: {
    "Content-type": "application/json"
  }
});